import { Request } from '@/lib/http';
import store from '@/store';
import AuthEnum from '../lib/enums/auth-enum';

const baseURL = '/api/im';

export default {
  getMenus() {
    const tenantId = store.getters.tenant.id;
    const request = new Request(`${baseURL}/${tenantId}/menus`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
};
